export var ACTION;
(function (ACTION) {
    ACTION["CONTACT_US"] = "CONTACT_US";
    ACTION["TRY_AGAIN"] = "TRY_AGAIN";
    ACTION["TRY_AGAIN_BANK"] = "TRY_AGAIN_BANK";
    ACTION["BACK_ACTION"] = "BACK_ACTION";
    ACTION["CONTINUE_ACTION"] = "CONTINUE_ACTION";
})(ACTION || (ACTION = {}));
